<template>
  <div>
    <v-container>
      <h1 class="primary--text font-weight-bold pb-4">
        {{
          isEditUnitType
            ? $t("property.unitType.updateUnitType")
            : $t("property.unitType.newUnitType")
        }}
      </h1>
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form v-on:submit.prevent="handleSubmit(onSave)" :key="reRender">
          <v-row align="center">
            <v-col cols="12" sm="6" md="6" class="py-0 pt-6">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="`${$t('settings.area.name')} (${$t('common.en')})`"
                  color="secondary"
                  type="text"
                  v-model="unitTypeModelObj.nameEn"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("settings.area.name") }} ({{ $t("common.en") }})
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="py-0 pt-6">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="`${$t('settings.area.name')} (${$t('common.ar')})`"
                  color="secondary"
                  type="text"
                  v-model="unitTypeModelObj.nameAr"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("settings.area.name") }} ({{ $t("common.ar") }})
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="9" sm="9" md="9" class="py-0 mx-auto">
              <!-- <div class="d-flex justify-space-around"> -->
              <!-- <v-btn class="custom-button text-none" @click="onCancel">
                  {{ $t("common.cancel") }}
                </v-btn> -->
              <v-btn
                class="white--text"
                color="primary"
                type="submit"
                width="100%"
                :loading="btnLoading"
              >
                {{ isEditUnitType ? $t("common.update") : $t("common.save") }}
              </v-btn>
              <!-- </div> -->
            </v-col>
            <v-col v-if="isError != null" cols="12" sm="12"
              ><Alert :message="isError" />
            </v-col>
          </v-row>
        </form>
      </ValidationObserver>
    </v-container>
  </div>
</template>
<script>
import "@/core/methods/validation_rules";
import { mapGetters } from "vuex";
import { createUnitType } from "../../methods/unitType/create_unit_type";
import { updateUnitType } from "../../methods/unitType/update_unit_type";
export default {
  data() {
    return {
      hasLogo: false,
      btnLoading: false,
      unitTypeModelObj: {
        nameAr: "",
        nameEn: ""
      },
      isError: null,
      reRender: 0
    };
  },
  components: {
    Alert: () => import("@/core/components/Alert.vue")
  },
  mounted() {
    if (this.isEditUnitType)
      this.unitTypeModelObj = this.$format.cloneVariable(this.editUnitType);
  },
  watch: {
    isEditUnitType: {
      handler() {
        if (this.isEditUnitType) {
          this.unitTypeModelObj = this.$format.cloneVariable(this.editUnitType);
        } else {
          this.unitTypeModelObj = {
            nameAr: "",
            nameEn: ""
          };
          this.reRender++;
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(["isEditUnitType", "editUnitType"])
  },
  methods: {
    async onSave() {
      this.btnLoading = true;
      const input = {
        input: this.$format.cloneVariable(this.unitTypeModelObj)
      };
      if (!this.isEditUnitType) {
        createUnitType(input).then(response => {
          if (response.data) {
            this.btnLoading = false;
            this.unitTypeModelObj = {
              nameAr: "",
              nameEn: ""
            };
            this.$root.$emit("refetchUnitType");
            this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("common.saveSuccess"),
              color: "green"
            });
          }
          if (response.graphQLErrors) {
            this.btnLoading = false;
            this.isError = response.graphQLErrors[0].message;
          }
        });
      } else {
        const updateInput = {
          id: input.input._id,
          input: {
            nameEn: input.input.nameEn,
            nameAr: input.input.nameAr
          }
        };
        updateUnitType(updateInput).then(response => {
          if (response.data) {
            this.btnLoading = false;
            this.$root.$emit("refetchUnitType");
            this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
            this.$store.commit("IS_EDIT_UNIT_TYPE", false);
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("common.updateSuccess"),
              color: "green"
            });
          }
          if (response.graphQLErrors) {
            this.btnLoading = false;
            this.isError = response.graphQLErrors[0].message;
            setTimeout(() => {
              this.isError = null;
            }, 5000);
          }
        });
      }
    },
    onCancel() {
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
      this.$store.commit("IS_EDIT_UNIT_TYPE", false);
    }
  }
};
</script>
